import React, {useEffect, useRef} from 'react'
import {Input, Label, FormGroup} from 'reactstrap'
import inteminateImgUrl from '../assets/icons/interminate-checkbox.svg'
import classnames from 'classnames'

const Checkbox = ({
    className,
    checked,
    indeterminate = false,
    preventChange = false,
    onChange,
    label,
    id,
    inputProps,
    labelProps,
}) => {
    const checkboxRef = useRef(null)

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate
        }
    }, [indeterminate])
    const handleChange = (e) => {
        if (preventChange) {
            return
            // e.stopPropagation()
        }
        if (onChange && !preventChange) {
            onChange(e)
        }
    }

    return (
        <FormGroup check className={classnames('CheckboxWrapper', className)}>
            <Label className="ms-2 text-body" {...labelProps}>
                <Input
                    id={id}
                    type="checkbox"
                    innerRef={checkboxRef}
                    checked={checked}
                    onChange={handleChange}
                    className={classnames('Checkbox', {
                        indeterminate: indeterminate,
                    })}
                    style={{
                        backgroundImage: indeterminate ? `url(${inteminateImgUrl})` : undefined,
                    }}
                    {...inputProps}
                />
                {label && label}
            </Label>
        </FormGroup>
    )
}

export default Checkbox
